import { jobCreators } from '../behavior/jobCreators-sidecar'
import { jobFillWith } from '../behavior/jobFillWith-sidecar'
import { jobLogger } from '../behavior/jobLogger-sidecar'
import { assert } from '../lib/assert-sidecar'
import { spriteMap } from '../main/spriteMap-sidecar'
import { IMachine } from './machines'
import { machinesAnims } from './machinesAnims-sidecar'
import { IMachineData } from './machinesData'
import { cargoes } from '../entities/cargoes-sidecar'
import { scene } from '../main/scene-sidecar'
import { common } from '../main/common-sidecar'

import { machines } from './machines-sidecar'

function ensure(obj: IMachine) {
  machines.ensureType(obj, 'o2gen')
}

const batteryRate = 0.5
const waterRate = 1
const hydrogenRate = 1

export function onCreate(obj: IMachine) {
  ensure(obj)
  obj.onUpdate = onUpdate
  let jc = jobCreators.create(
    () => {
      if (obj.waterSupply > 0) {
        return false
      }
      if (!cargoes.existsOfType('water')) {
        return false
      }
      return true
    },
    () => {
      let j = jobFillWith.create('water', (job) => {
        let mc = jobLogger.assertMachine(job, (c) => c === obj)
        mc.waterSupply += 100
        return true
      })
      j.machine = obj
      return j
    },
  )
  obj.jobCreators.push(jc)

  jc = jobCreators.create(
    () => {
      if (obj.batterySupply > 0) {
        return false
      }
      if (!cargoes.existsOfType('power')) {
        return false
      }
      return true
    },
    () => {
      let j = jobFillWith.create('power', (job) => {
        let mc = jobLogger.assertMachine(job, (c) => c === obj)
        mc.batterySupply += 100
        return true
      })
      j.machine = obj
      return j
    },
  )
  obj.jobCreators.push(jc)
}

export function isRunning(obj: IMachine) {
  ensure(obj)
  return obj.waterSupply > 0 && obj.batterySupply > 0
}

export function onUpdate(obj: IMachine) {
  ensure(obj)
  let ds = common.getUpdateDeltaScaled()
  let ctx = scene.getContext()
  if (obj.hydrogenSupply > 100) {
    obj.hydrogenSupply -= 100
    let cg = cargoes.create('hydrogen')
    cargoes.moveToTile(cg, ctx.mapShip, obj.i + 1, obj.j)
  }

  if (isRunning(obj)) {
    machinesAnims.playAnim(obj, machinesAnims.all.o2Go)
    machinesAnims.updateAnim(obj)

    obj.batterySupply -= batteryRate * ds
    obj.waterSupply -= waterRate * ds
    obj.hydrogenSupply += hydrogenRate * ds
  } else {
    let frame = 0
    if (obj.batterySupply > 0) {
      frame = 2
    }
    if (obj.waterSupply > 0) {
      frame = 1
    }

    spriteMap.setFrame(obj.image, obj.data.frames[frame])
  }

  // let ctx = scene.getContext()
  // if (obj.waterSupply <= 0) {
  // } else {
  //   obj.waterSupply = 0
  //   let cg = cargoes.create('water')
  //   cargoes.moveToTile(cg, ctx.mapShip, obj.i + 1, obj.j)
  // }
}
